import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  Tabs,
  Tab,
  TextField,
  IconButton,
  Toolbar,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  InputAdornment,
  Modal,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Card,
} from "@mui/material";
import { Search, Visibility } from "@mui/icons-material";

import { Button, ModalClose, Sheet, Stack } from "@mui/joy";
import EditIcon from "@mui/icons-material/Edit";
import { BASE_URL_TEST } from "../../utils/baseUrl";
import { urls } from "../../urls/urls";
import { useFetch, useFetchById, usePut } from "../../hooks";
import { useDispatch, useSelector } from "react-redux";
import { setModalProperties } from "../../store/actions/userActions";


export default function Adminregularorder() {
  const dispatch = useDispatch();
  const [selectedTab, setSelectedTab] = useState(0);
  const [searchValue, setSearchValue] = useState("");
  const [open, setOpen] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [status, setStatus] = useState("");
  const [trackingNumber, setTrackingNumber] = useState("");
  const [showOTP, setShowOTP] = useState(false);
  const [otp, setOtp] = useState(["1", "2", "3", "4", "5", "6"]);
  const inputRefs = useRef([]);
  const [orderMData, setOrderMData] = useState([]);
  const [reload, setReload] = useState(0);
  const loginToken = useSelector((state) => state.user.logintoken);
  const { id } = useSelector((state) => state.user.userdetails);

  const statuses = [
    { label: "PENDING", value: "PENDING" },
    { label: "Confirmed", value: "Confirmed" },
    { label: "Processing", value: "Processing" },
    { label: "Picked", value: "Picked" },
    { label: "Shipped", value: "Shipped" },
    { label: "Delivered", value: "Delivered" },
    { label: "Cancelled", value: "Cancelled" },
    { label: "Site-Admin", value: "Site-Admin" },
    { label: "Returned", value: "Returned" },
  ];

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };
  const handleSearchChange = (event) => {
    setSearchValue(event.target.value);
  };

  const handleEditClick = (order) => {
    console.log("pen clicked", order);
    setSelectedOrder(order);
    setTrackingNumber(order.trackingNumber);
    // setStatus(order.status);
    setOpen(true);
  };
  const handleChange = (e, index) => {
    const value = e.target.value;
    if (/^[0-9]?$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);
      if (value && index < 5) {
        inputRefs.current[index + 1].focus();
      }
    }
  };
  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

  const handleUpdateOrder = () => {
    console.log("ordered data", selectedOrder);
    // const updatedOrders = orderData.map((order) => {
    //   if (order.id === selectedOrder.id) {
    //     return { ...order, status, trackingNumber };
    //   }
    //   return order;
    // });
    // setOrderData(updatedOrders);

    orderStatusPutData({
      cart_id: selectedOrder.cart_id,
      vendor_id: selectedOrder.vendor_id,
      order_status: status,
    });

    //  setOpen(false);
  };
  const handleOrderStatus = (buttonType, product) => {
    console.log("cartid", product.cart_id);
    console.log("cartid vid", product.vendor_id);
    orderStatusPutData({
      cart_id: product.cart_id,
      vendor_id: product.vendor_id,
      order_status: buttonType,
    });
  };

  const handleStatusChange = (event) => {
    setStatus(event.target.value);
  };
const filteredOrders = (Array.isArray(orderMData) ? orderMData : []).filter((order) =>
  order.cart_number?.toLowerCase().includes(searchValue.toLowerCase())
);
  var PendingFilteredData = orderMData.filter(
    (item) => item.order_status === "PENDING"
  );

  const ConfirmedFilteredData = orderMData.filter(
    (item) => item.order_status === "Confirmed"
  );

  const ProcessingFilteredData = orderMData.filter(
    (o) => o.order_status === "Processing"
  );
  const PickedFilteredData = orderMData.filter(
    (o) => o.order_status === "Picked"
  );
  const ShippedFilteredData = orderMData.filter(
    (o) => o.order_status === "Shipped"
  );
  const DeliveredFilteredData = orderMData.filter(
    (o) => o.order_status === "Delivered"
  );
  const CancelledFilteredData = orderMData.filter(
    (o) => o.order_status === "Cancelled"
  );

  console.log("PendingFilteredData", PendingFilteredData);

  const tabDataMap = {
    0: PendingFilteredData,
    1: ConfirmedFilteredData,
    2: ProcessingFilteredData,
    3: PickedFilteredData,
    4: ShippedFilteredData,
    5: DeliveredFilteredData,
    6: CancelledFilteredData,
  };

    const {
      data: ordersData,
      error: ordersDataError,
      fetchData: fetchOrdersData,
    } = useFetch(BASE_URL_TEST + urls("fetchAllOrders"), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: loginToken ? `Bearer ${loginToken}` : "",
      },
    });

  const {
    data: statusesData,
    error: statusesDataError,
    fetchDataById: fetchStatusData,
  } = useFetchById(BASE_URL_TEST, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  const {
    data: orderStatusData,
    error: orderStatusDataError,
    putData: orderStatusPutData,
  } = usePut(BASE_URL_TEST + "/" + urls("cancelOrder"), {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });
  const tabStatusMap = {
  0: "PENDING",
  1: "Confirmed",
  2: "Processing",
  3: "Picked",
  4: "Shipped",
  5: "Delivered",
  6: "Cancelled",
};

useEffect(() => {
if (!loginToken) {
    console.warn("⚠️ Regular -  token not ready:", { id, loginToken });
    return;
  }
 console.log("🚀 Regular - Calling fetchAllOrders with:", {
    type: "regular",
    order_status: tabStatusMap[selectedTab],
  });
  fetchOrdersData({
    type: "regular",
  order_status: tabStatusMap[selectedTab], 
  });
}, [loginToken, selectedTab, reload]);   // ✅ add selectedTab
  // Fetch status when order is selected
 useEffect(() => {
  if (!selectedOrder) return; // don't fire until an order is actually selected

  const targetId = selectedOrder?.order_status_id ?? selectedOrder?.cart_id; 
  // ^ replace with whatever field this endpoint actually expects — see below

  if (!targetId) {
    console.warn("⚠️ Regular - missing id for getStatusById", selectedOrder);
    return;
  }

  const catByIdUrl = urls("getStatusById", targetId);
  fetchStatusData(catByIdUrl);
}, [selectedOrder]);

  // Handle orders data response
 useEffect(() => {
  if (ordersDataError) {
    console.log("❌ Regular - fetchAllOrders ERROR:", ordersDataError);
  } else if (ordersData) {
  console.log("✅ Regular - fetchAllOrders RESPONSE:", ordersData);
  if (ordersData.status === true) {
    console.log("✅ Regular - Orders Data:", ordersData.data);
    const orders = ordersData.data?.ordersData;
    setOrderMData(Array.isArray(orders) ? orders : []);
  } else {
    console.log("ℹ️ Regular - No orders found:", ordersData.message);
    setOrderMData([]);
  }
  }
}, [ordersData, ordersDataError]);

  // Handle order status update response
  useEffect(() => {
    if (orderStatusDataError) {
    } else if (orderStatusData && orderStatusData["status"] === true) {
      console.log("selectedTab resp", selectedTab);
      if (selectedTab === 1 || selectedTab === 0) {
        setReload(1);
        setOpen(false);
      } else {
        setReload(0);
      }
      dispatch(
        setModalProperties({
          showModal: true,
          modalMessage: orderStatusData["message"],
        })
      );
    }
  }, [orderStatusData, orderStatusDataError]);
  return (
    <Box
      component="main"
      sx={{ flexGrow: 1, bgcolor: "#EEF2FF", p: 0, overflowY: "auto" }}
    >
      <Tabs value={selectedTab} onChange={handleTabChange} sx={{ mb: 2 }}>
        <Tab
          label="Pending"
          sx={{ color: selectedTab === 0 ? "#4F46E5" : "inherit" }}
        />
        <Tab
          label="Confirmed"
          sx={{ color: selectedTab === 1 ? "#4F46E5" : "inherit" }}
        />
        <Tab
          label="Processing"
          sx={{ color: selectedTab === 2 ? "#4F46E5" : "inherit" }}
        />
        <Tab
          label="Picked"
          sx={{ color: selectedTab === 3 ? "#4F46E5" : "inherit" }}
        />
        <Tab
          label="Shipped"
          sx={{ color: selectedTab === 4 ? "#4F46E5" : "inherit" }}
        />
        <Tab
          label="Delivered"
          sx={{ color: selectedTab === 5 ? "#4F46E5" : "inherit" }}
        />
        <Tab
          label="Cancelled"
          sx={{ color: selectedTab === 6 ? "#4F46E5" : "inherit" }}
        />
      </Tabs>

      <Box sx={{ display: "flex", alignItems: "center", mb: 3 }}>
        <TextField
          placeholder="Search by order id"
          variant="outlined"
          size="small"
          value={searchValue}
          onChange={handleSearchChange}
          sx={{ width: "300px" }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Search />
              </InputAdornment>
            ),
          }}
        />
      </Box>
      {/* Orders Table */}
      <TableContainer component={Paper} sx={{ borderRadius: "20px" }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>ORDER ID</TableCell>
              <TableCell>TRACKING NUMBER</TableCell>
              <TableCell>CREATED</TableCell>
              <TableCell>CUSTOMER</TableCell>
              <TableCell>TOTAL</TableCell>
              <TableCell>PAYMENT TYPE</TableCell>
              <TableCell>STATUS</TableCell>
              <TableCell align="right">ACTIONS</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {tabDataMap[selectedTab] && tabDataMap[selectedTab].length > 0 ? (
              tabDataMap[selectedTab].map((item) => (
               <TableRow key={item.cart_id}>
  <TableCell>{item?.cartDetails?.cart_number}</TableCell>
  <TableCell>{item?.cartDetails?.transaction_id}</TableCell>
  <TableCell>{item?.created_at}</TableCell>
  <TableCell>
    {item?.cartDetails?.customerDetails?.first_name}{" "}
    {item?.cartDetails?.customerDetails?.last_name}
  </TableCell>
  <TableCell>{item?.cartDetails?.cart_total_amount}</TableCell>
  <TableCell>{item?.cartDetails?.payment_method}</TableCell>
  <TableCell>{item?.order_status}</TableCell>
                  {/* ACTIONS CELL */}
                  <TableCell align="right">
                    <IconButton
                      sx={{
                        color: "#4F46E5",
                        "&:hover": {
                          backgroundColor: "#EEF2FF",
                        },
                      }}
                      onClick={() => handleEditClick(item)}
                    >
                      <Visibility />
                    </IconButton>

                    {/* EDIT MODAL */}
                    <Modal
                      aria-labelledby="modal-title"
                      aria-describedby="modal-desc"
                      open={open}
                      onClose={() => setOpen(false)}
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                      BackdropProps={{
                        style: { backgroundColor: "rgba(0, 0, 0, 0.2)" },
                      }}
                    >
                      <Sheet
                        variant="outlined"
                        sx={{
                          maxWidth: "700px",
                          width: "100%",
                          borderRadius: "md",
                          p: 3,
                        }}
                      >
                        <ModalClose
                          variant="plain"
                          sx={{ m: 1 }}
                          onClick={() => setOpen(false)}
                        />

                        <Typography
                          sx={{
                            fontSize: 20,
                            textAlign: "center",
                            fontWeight: "bold",
                          }}
                        >
                          Edit Order Details
                        </Typography>

                        {selectedOrder && (
                          <Stack
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              gap: 2,
                            }}
                          >
                            <Typography variant="body1" gutterBottom>
                              <span style={{ fontWeight: "bold" }}>
                                Order ID:
                              </span>{" "}
                              {selectedOrder.cart_number}
                            </Typography>
                            <Typography variant="body1" gutterBottom>
                              <span style={{ fontWeight: "bold" }}>
                                Created:
                              </span>{" "}
                              {selectedOrder?.cart?.created_at}
                            </Typography>
                            <Typography variant="body1" gutterBottom>
                              <span style={{ fontWeight: "bold" }}>
                                Customer:
                              </span>{" "}
                              {selectedOrder?.cart?.customerDetails?.first_name}{" "}
                              {selectedOrder?.cart?.customerDetails?.last_name}
                            </Typography>
                            <Typography variant="body1" gutterBottom>
                              <span style={{ fontWeight: "bold" }}>Total:</span>{" "}
                              {selectedOrder.total_amount}
                            </Typography>

                            {/* Tracking Number Input */}
                            <FormControl fullWidth>
                              <TextField
                                label="Tracking Number"
                                variant="outlined"
                                size="small"
                                sx={{ mb: 2, display: "none" }}
                                value={trackingNumber}
                                onChange={(e) =>
                                  setTrackingNumber(e.target.value)
                                }
                              />
                            </FormControl>

                            {/* Status Dropdown */}
                            <FormControl fullWidth>
                              <InputLabel>Status</InputLabel>
                              <Select
                                label="Status"
                                value={status}
                                onChange={handleStatusChange}
                                size="small"
                                sx={{ mb: 2 }}
                              >
                                {statuses.map((item) => (
                                  <MenuItem key={item.value} value={item.value}>
                                    {item.value}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>

                            {status === "Confirmed" ? (
                              <Card
                                sx={{
                                  padding: 2,
                                  marginBottom: 2,
                                  backgroundColor: "#f9f9f9",
                                }}
                              >
                                {/* OTP Section */}
                                {status === "Confirmed" && (
                                  <>
                                    <IconButton
                                      onClick={() => setShowOTP(false)}
                                      sx={{
                                        alignSelf: "flex-start",
                                        color: "white",
                                      }}
                                    >
                                      {/* <ArrowBackIcon /> */}
                                    </IconButton>

                                    <Typography variant="h6" fontWeight="bold">
                                      OTP Verification
                                    </Typography>
                                    <Typography>OTP has been sent</Typography>

                                    <Box mt={3} display="flex" gap={1}>
                                      {otp.map((digit, index) => (
                                        <TextField
                                          key={index}
                                          value={digit}
                                          inputRef={(el) =>
                                            (inputRefs.current[index] = el)
                                          }
                                          variant="outlined"
                                          sx={{
                                            width: 50,
                                            background: "white",
                                            borderRadius: "8px",
                                          }}
                                          inputProps={{
                                            maxLength: 1,
                                            style: { textAlign: "center" },
                                          }}
                                          onChange={(e) =>
                                            handleChange(e, index)
                                          }
                                          onKeyDown={(e) =>
                                            handleKeyDown(e, index)
                                          }
                                        />
                                      ))}
                                    </Box>
                                  </>
                                )}
                              </Card>
                            ) : null}

                            {/* Update Button */}
                            <Button
                              sx={{
                                backgroundColor: "#4F46E5",
                                alignContent: "center",
                                color: "white",
                              }}
                              onClick={handleUpdateOrder}
                            >
                              Update
                            </Button>
                          </Stack>
                        )}
                      </Sheet>
                    </Modal>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={8} align="center">
                  <Typography variant="body2">No Data Found</Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mt: 2,
        }}
      >
        <Typography variant="body2">
          Showing {filteredOrders.length} of {orderMData.length}
        </Typography>
        <Box>
          <IconButton sx={{ color: "#4F46E5" }}>⟨</IconButton>
          {[1, 2, 3, 4, 5].map((page) => (
            <IconButton key={page} sx={{ color: "#4F46E5" }}>
              {page}
            </IconButton>
          ))}
          <IconButton sx={{ color: "#4F46E5" }}>⟩</IconButton>
        </Box>
      </Box>
    </Box>
  );
}
